import { FaUserCog } from "react-icons/fa";
import GenericDialog from "../shared/GenericDialog";
import DirectPlaySettingsRow from "./DirectPlaySettingsRow";
import DarkmodeSettingsRow from "./DarkmodeSettingsRow";
import NotificationSettingsRow from "./NotificationSettingsRow";

export default function GlobalSettingsDialog({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}) {
  return (
    <GenericDialog
      header="Personal Settings"
      headerIcon={<FaUserCog size={20} />}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    >
      <DirectPlaySettingsRow />
      <DarkmodeSettingsRow />
      <NotificationSettingsRow />
    </GenericDialog>
  );
}
